
import { useState } from 'react';

export default function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formData = new URLSearchParams();
      formData.append('email', email);

      const response = await fetch('https://readdy.ai/api/form/d3ma6shvbfpiajvfc790', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formData
      });

      if (response.ok) {
        setSubmitStatus('success');
        setEmail('');
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="py-20 bg-teal-600">
      <div className="container mx-auto px-6 text-center">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            獲取最新項目資訊
          </h2>
          <p className="text-xl text-teal-100 mb-8 leading-relaxed">
            訂閱我們的電子報，第一時間了解石垣市真榮里宮鳥開發計畫的最新進展、優惠資訊和重要公告。
          </p>
          
          <form onSubmit={handleSubmit} data-readdy-form id="newsletter-subscription" className="max-w-md mx-auto">
            <div className="flex flex-col sm:flex-row gap-4">
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="請輸入您的電子郵件"
                required
                className="flex-1 px-6 py-4 rounded-lg text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-white text-sm"
              />
              <button
                type="submit"
                disabled={isSubmitting}
                className="bg-white text-teal-600 px-8 py-4 rounded-lg font-semibold hover:bg-gray-100 transition-colors disabled:bg-gray-300 disabled:cursor-not-allowed cursor-pointer whitespace-nowrap"
              >
                {isSubmitting ? (
                  <>
                    <i className="ri-loader-4-line animate-spin mr-2"></i>
                    訂閱中...
                  </>
                ) : (
                  <>
                    <i className="ri-mail-send-line mr-2"></i>
                    立即訂閱
                  </>
                )}
              </button>
            </div>
            
            {submitStatus === 'success' && (
              <div className="mt-4 p-4 bg-green-100 border border-green-400 text-green-700 rounded-lg">
                <i className="ri-check-circle-line mr-2"></i>
                訂閱成功！感謝您的關注。
              </div>
            )}
            
            {submitStatus === 'error' && (
              <div className="mt-4 p-4 bg-red-100 border border-red-400 text-red-700 rounded-lg">
                <i className="ri-error-warning-line mr-2"></i>
                訂閱失敗，請稍後再試。
              </div>
            )}
          </form>
          
          <p className="text-teal-200 text-sm mt-6">
            我們承諾保護您的隱私，不會將您的資訊分享給第三方。您可以隨時取消訂閱。
          </p>
        </div>
      </div>
    </section>
  );
}
